import { render, staticRenderFns } from "./IotSetupSidebarUser.vue?vue&type=template&id=70b45450&scoped=true"
import script from "./IotSetupSidebarUser.vue?vue&type=script&lang=js"
export * from "./IotSetupSidebarUser.vue?vue&type=script&lang=js"
import style0 from "./IotSetupSidebarUser.vue?vue&type=style&index=0&id=70b45450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b45450",
  null
  
)

export default component.exports